import { useEffect } from 'react'
import {
  Dialog,
  Heading,
  Stack,
  Text,
  useModal
} from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from 'lmcv/components/Icon'

import * as S from './styles'

const ModalWarning = () => {
  const { setModal } = useModal()

  useEffect(() => {
    setModal({
      appElement: 'body',
      hasScroll: true,
      size: 'giga',
      children: ({ onClose }) => (
        <Dialog title="Aviso" onClose={onClose}>
          <S.Container>
            <Stack spacing="bit">
              <Icon name="warning" />
              <Heading size="mega">Atenção!</Heading>

              <Text>
                <Text bold as="strong">
                  Uma campanha falsa sobre a Black Friday 2020 está sendo
                  divulgada{' '}
                </Text>
                na internet em nome da Leroy Merlin. O perfil falso envia um
                link de uma ação de Responda e Ganhe, ofertando um
                Ar-Condicionado portátil.
              </Text>

              <Text>
                <Text bold as="strong">
                  Não fazemos sorteios
                </Text>{' '}
                e nem ações de Responda e Ganhe. Por isso, caso receba essa
                campanha,{' '}
                <Text bold as="strong">
                  não forneça dados pessoais
                </Text>
                , não acesse links externos e nem preencha questionários
              </Text>
              <S.TextHighlight bold>
                Estamos tomando as providências necessárias.
              </S.TextHighlight>
            </Stack>
          </S.Container>
        </Dialog>
      )
    })
  }, [setModal])

  return null
}

export default ModalWarning
